export const UPLOADED_SHEET_COLUMNS = [
  { title: "SN" },
  {
    title: "Uploaded By",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["createdBy", "fullName"],
  },
  {
    title: "Uploaded At",
    sortArrow: true,
    sortBy: "date",
    address: ["createdAt"],
  },
  {
    title: "Download",
  },
  { title: "View" },
];
